import { isAxiosError } from 'axios';

interface ApiErrorBody {
  message?: string;
}

export function apiErrorMessage(error: unknown): string {
  if (isAxiosError<ApiErrorBody>(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return error instanceof Error ? error.message : String(error);
}
